import { render, staticRenderFns } from "./CompanyToolbar.vue?vue&type=template&id=1b8a9f88&"
import script from "./CompanyToolbar.vue?vue&type=script&lang=js&"
export * from "./CompanyToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports